import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Locale } from '../redux/models/locale.model';
import { of } from 'rxjs';
import { localeMockResponse } from '../../login/locale.mock';

@Injectable({
  providedIn: 'root',
})
export class BackendService {
  constructor(
  ) {}

  getLocales(): Observable<Locale[]> {
    return of(localeMockResponse);
  }
}
